import {
  buildCalendarVisitSchedule,
  createCalendarVisitSchedule
} from '../calendarVisitSchedule.schema';
import { checkCooperative } from './checkCooperative';
import { checkLinkWithPadPrescription } from './checkLinkWithPadPrescription';
import { checkSuspensionVisit } from './checkSuspensionVisit';

/**
 * Transforms a single padVisit into a genericVisit structure.
 * Pure function with no side effects.
 */
export const transformPadVisitToCalendarVisitScheduleCooperative = (padVisit = {}) => {
  if (!shouldIncludeAsCalendarVisitScheduleCooperative(padVisit)) return [];

  return createCalendarVisitSchedule(buildCalendarVisitSchedule(padVisit));
};

const shouldIncludeAsCalendarVisitScheduleCooperative = padVisit => {
  const isCooperative = checkCooperative(padVisit);
  const isSuspensionVisit = checkSuspensionVisit(padVisit);
  const hasLinkWithPadPrescription = checkLinkWithPadPrescription(padVisit);

  return isCooperative && !isSuspensionVisit && !hasLinkWithPadPrescription;
};
